import { ApiService } from "../model/Api.model";
import { AxiosInstance } from "axios";
import { IPrecatorio } from "../interfaces/UserInterface";
import { IGetSummary } from "../interfaces/IGetSummary";

enum PrecatorioServiceEnum {
  getAll = "/all",
  getById = "/",
  getUpdatePriceById = "/{precatorioId}/updated-price",
  getTaxaById = "{precatorioId}/taxa",
  postSummaryByRecaptchaToken = "/summary?recaptcha=",
  postOffline = "/offline?recaptcha={token}&x=sdfsdf",
  postLandingPage = "/landing-page-form-submit"
}

export default class PrecatorioService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/precatorio");
  }

  public getAll = async (): Promise<IPrecatorio[]> => await this.GET(PrecatorioServiceEnum.getAll);
  public getById = async (id: number): Promise<IPrecatorio> => await this.GET(PrecatorioServiceEnum.getById + id);
  public getUpdatePriceById = async (id: number): Promise<IPrecatorio> => await this.GET(PrecatorioServiceEnum.getUpdatePriceById.replace("{precatorioId}", id.toString()));
  public getTaxaById = async (id: number): Promise<any> => await this.GET(PrecatorioServiceEnum.getTaxaById.replace("{precatorioId}", id.toString()));
  public postSummaryByRecaptchaToken = async (token, data: any): Promise<IGetSummary> => await this.POST(PrecatorioServiceEnum.postSummaryByRecaptchaToken + token, data);
  public postOffline = async (token, data: IPrecatorio): Promise<any> => await this.POST(PrecatorioServiceEnum.postOffline.replace("{token}", token), data);
  public postLandingPage = async (data: any): Promise<any> => await this.POST(PrecatorioServiceEnum.postLandingPage, data);
}



// WEBPACK FOOTER //
// ./src/services/api/Precatorio.service.ts